/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import2 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import3 from '../../orchestration/page';
import * as import4 from '../../orchestration/navigation.service';
import * as import5 from '../order-details-panel/order-details-panel.component.ngfactory';
import * as import6 from '../order-details-panel/order-details-panel.component';
import * as import7 from '../../orchestration/session.model';
import * as import8 from '../../ordering-context/ordering-context.model';
import * as import9 from '../order.model';
import * as import10 from './order-details-page.component';
import * as import11 from '../../orchestration/navigation-params';
const styles_OrderDetailsPageComponent:any[] = ([] as any[]);
export const RenderType_OrderDetailsPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderDetailsPageComponent,
  data: {}
}
);
export function View_OrderDetailsPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import1.View_ModalPageLayoutComponent_0,import1.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import2.ModalPageLayoutComponent,[
      import3.Page,
      import4.NavigationService
    ]
      ,{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import3.PageLayout,(null as any),[import2.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,1,'woa-order-details-panel',[[
        'class',
        'order-details'
      ]
    ],(null as any),(null as any),(null as any),import5.View_OrderDetailsPanelComponent_0,import5.RenderType_OrderDetailsPanelComponent)),
    import0.ɵdid(573440,(null as any),0,import6.OrderDetailsPanelComponent,[
      import7.SessionModel,
      import8.OrderingContextModel,
      import9.OrderModel,
      import4.NavigationService
    ]
      ,{recentOrder: [
        0,
        'recentOrder'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import10.OrderDetailsPageComponent = v.component;
    const currVal_0:any = 'woa.heading.order-details.title';
    ck(v,2,0,currVal_0);
    const currVal_1:any = co.recentOrder;
    ck(v,8,0,currVal_1);
  },(null as any));
}
function View_OrderDetailsPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-order-details-page',([] as any[]),(null as any),(null as any),(null as any),View_OrderDetailsPageComponent_0,RenderType_OrderDetailsPageComponent)),
    import0.ɵdid(49152,(null as any),0,import10.OrderDetailsPageComponent,[import11.NavigationParams],(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import3.Page,(null as any),[import10.OrderDetailsPageComponent])
  ]
  ,(null as any),(null as any));
}
export const OrderDetailsPageComponentNgFactory:import0.ComponentFactory<import10.OrderDetailsPageComponent> = import0.ɵccf('woa-order-details-page',import10.OrderDetailsPageComponent,View_OrderDetailsPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXIvb3JkZXItZGV0YWlscy1wYWdlL29yZGVyLWRldGFpbHMtcGFnZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9vcmRlci9vcmRlci1kZXRhaWxzLXBhZ2Uvb3JkZXItZGV0YWlscy1wYWdlLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXIvb3JkZXItZGV0YWlscy1wYWdlL29yZGVyLWRldGFpbHMtcGFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JkZXIvb3JkZXItZGV0YWlscy1wYWdlL29yZGVyLWRldGFpbHMtcGFnZS5jb21wb25lbnQudHMuT3JkZXJEZXRhaWxzUGFnZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjx3b2EtbW9kYWwtcGFnZS1sYXlvdXQgW3RpdGxlXT1cIid3b2EuaGVhZGluZy5vcmRlci1kZXRhaWxzLnRpdGxlJ1wiPlxuICAgIDx3b2Etb3JkZXItZGV0YWlscy1wYW5lbCBjbGFzcz1cIm9yZGVyLWRldGFpbHNcIiBbcmVjZW50T3JkZXJdPVwicmVjZW50T3JkZXJcIj48L3dvYS1vcmRlci1kZXRhaWxzLXBhbmVsPlxuPC93b2EtbW9kYWwtcGFnZS1sYXlvdXQ+XG4iLCI8d29hLW9yZGVyLWRldGFpbHMtcGFnZT48L3dvYS1vcmRlci1kZXRhaWxzLXBhZ2U+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtnQkFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1FO01BQy9EO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXFHO0lBQ2pGOzs7O0lBRkQ7SUFBdkIsU0FBdUIsU0FBdkI7SUFDbUQ7SUFBL0MsU0FBK0MsU0FBL0M7Ozs7O0lDREo7Z0JBQUE7Z0JBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/app/order/order-details-page/order-details-page.component.ngfactory.ts